import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 24"
}, n = /* @__PURE__ */ e("g", { "clip-path": "url(#map-point-outline_svg__a)" }, [
  /* @__PURE__ */ e("path", {
    fill: "currentColor",
    "fill-rule": "evenodd",
    d: "M.273 9.974C.273 4.63 4.533.273 9.818.273s9.546 4.357 9.546 9.701c0 2.58-.735 5.351-2.036 7.744-1.298 2.39-3.194 4.468-5.568 5.577a4.58 4.58 0 0 1-3.883 0c-2.374-1.11-4.27-3.185-5.568-5.577-1.3-2.393-2.036-5.164-2.036-7.744M9.818 1.91c-4.355 0-7.909 3.597-7.909 8.065 0 2.288.658 4.791 1.837 6.963 1.18 2.175 2.85 3.954 4.822 4.876a2.95 2.95 0 0 0 2.5 0c1.973-.922 3.642-2.701 4.822-4.876 1.18-2.17 1.837-4.675 1.837-6.963 0-4.468-3.554-8.065-7.909-8.065m0 5.455a2.454 2.454 0 1 0 0 4.908 2.454 2.454 0 0 0 0-4.908m-4.09 2.454a4.09 4.09 0 1 1 8.181 0 4.09 4.09 0 0 1-8.182 0Z",
    "clip-rule": "evenodd"
  })
], -1), c = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "map-point-outline_svg__a" }, [
    /* @__PURE__ */ e("path", {
      fill: "currentColor",
      d: "M0 0h19.636v24H0z"
    })
  ])
], -1), i = [
  n,
  c
];
function r(a, s) {
  return t(), o("svg", l, [...i]);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
